import { useTranslations } from '@vp/om-translations';
import { trackBuyItAgainCheckoutClicked } from '../../../apis/newrelic/newRelicTrackingApi';
import { useSiteData } from '../../../hooks/useSiteData';
import { useSourcePageContext } from '../../contexts/SourcePageContext';
import { useLineItemData } from '../../contexts/LineItemDataContext';
import { Link } from '@vp/swan';
import { BUY_IT_AGAIN_SOURCE_PAGE } from '../../../constants/sourcePage';

export const BIACheckoutLink = () => {
  const [buyItAgainMessages = {}] = useTranslations(['buyItAgainMessages']);

  const {
    vistacartTenant: vistacartTenantName,
    externalAppNavigation: { checkout: checkoutUrl },
  } = useSiteData();

  const { sourcePage } = useSourcePageContext();

  const { id, orderNumber } = useLineItemData();

  const checkoutLinkHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (sourcePage === BUY_IT_AGAIN_SOURCE_PAGE) {
      trackBuyItAgainCheckoutClicked({
        orderNumber,
        itemId: id,
        vistacartTenantName,
        page: sourcePage,
      });
    }

    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };

  return (
    <Link href={checkoutUrl} onClick={checkoutLinkHandler} skin="cta">
      {buyItAgainMessages.checkout}
    </Link>
  );
};
